import React from "react"
import { TextFieldSeeker } from "@ui-seeker/core"

import { AppFormGrid, AppFormSection, AppPillToggle } from "@components"
import { LIMITS } from "./@services/profile"
import { Cell, FieldLabel, Helper, NOT_SET, fromPill, toPill } from "./fields"


// Labels and the line under the tone; codes the server adds later still show, capitalised (patterns § 5)
const TONES = {
	direct: { label: 'Direct', help: 'the decision first, the reasoning after.' },
	coaching: { label: 'Coaching', help: 'explains the reasoning as it goes.' },
	executive: { label: 'Executive', help: 'impact and number, summary style.' },
}
const LANGS = { es: 'Español', en: 'English' }
const capital = (code) => String(code).charAt(0).toUpperCase() + String(code).slice(1)

/** "How she talks to you": tone, language, notes about the business. */
export default function VoiceSection({ value, options, onPatch, disabled }) {
	const preset = value.voice.preset
	const notes = value.voice.notes || ''
	const tones = (options?.voice_presets || Object.keys(TONES)).map(code => ({ value: code, label: TONES[code]?.label || capital(code) }))
	const langs = (options?.langs || Object.keys(LANGS)).map(code => ({ value: code, label: LANGS[code] || String(code).toUpperCase() }))

	return <AppFormSection icon="comment" title="How she talks to you" hint="Tone, language, and anything about your business the data cannot know.">
		<AppFormGrid>
			<Cell span={6}>
				<FieldLabel>Tone</FieldLabel>
				<AppPillToggle
					size="small" aria-label="Tone"
					value={toPill(preset)}
					options={[{ value: NOT_SET, label: 'Not set' }, ...tones]}
					onChange={v => !disabled && onPatch({ voice: { preset: fromPill(v) } })}
				/>
				<Helper>{preset
					? <><b>{TONES[preset]?.label || capital(preset)}</b>{TONES[preset] ? ` — ${TONES[preset].help}` : ''}</>
					: <><b>Not set</b> — nothing about tone travels to Iris.</>}</Helper>
			</Cell>
			<Cell span={6}>
				<FieldLabel>Language</FieldLabel>
				<AppPillToggle
					size="small" aria-label="Language"
					value={toPill(value.lang)}
					options={[{ value: NOT_SET, label: 'Not set' }, ...langs]}
					onChange={v => !disabled && onPatch({ lang: fromPill(v) })}
				/>
				<Helper>The language of every answer, whatever language you write in. <b>Not set</b> — Iris keeps her default.</Helper>
			</Cell>
			<Cell span={12}>
				<FieldLabel component="label" count={notes.length} max={LIMITS.notes}>Notes about your business</FieldLabel>
				<TextFieldSeeker
					multiline rows={3}
					disabled={disabled}
					value={notes}
					onChange={e => onPatch({ voice: { notes: e.target.value.slice(0, LIMITS.notes) } })}
					inputProps={{ maxLength: LIMITS.notes, 'aria-label': 'Notes about your business' }}
					placeholder="e.g. In August I never go below €45/day at TFS · some brand is not real competition for me"
				/>
				<Helper>Facts, not filters — anything that should narrow the <b>data</b> belongs in the sections below, so she can query it instead of guessing. These are <b>preferences</b>: if a note contradicts what the data says, Iris follows the data and tells you.</Helper>
			</Cell>
		</AppFormGrid>
	</AppFormSection>
}
